<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Assets</p>
          <div>
            <el-tooltip content="Upload tracks" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-upload2"
                @click="upload()"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
        <Upload />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Upload from '../components/youtube/assets/DialogUpload'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  components: {
    Upload
  },

  computed: {
    ...mapState('youtubeAssets', ['loading'])
  },

  methods: {
    ...mapMutations('youtubeAssets', ['setDialog']),
    ...mapActions('youtubeAssets', ['read']),
    upload() {
      //this.setDialog(true)
      this.read()
    }
  }
}
</script>
